<template>
    <div>
        <v-dialog v-model="individualKPIdialog" max-width="900px">
          <v-card>
            <v-card-text>
              <v-container>
                    <v-row>
                        <span style="font-weight: bold;" class="mb-2 mt-6">{{$t('performancemanagement.createnewkpi')}}</span>
                    </v-row>

                    <div>
                        <v-row class="pb-n4 mb-4 mt-0">
                            <v-col cols="9" class="ml-0 pl-0">
                                <v-radio-group class="mt-2" v-model="radioSelected" row>
                                    <v-radio
                                        :value="1"
                                    >
                                        <template v-slot:label>
                                            <span class="radio-label">{{$t('pmreviewexercisesectioncard.individualkpi')}}</span>
                                        </template>
                                    </v-radio>
                                    <!-- <v-radio
                                        :value="2"
                                    >
                                        <template v-slot:label>
                                            <span class="radio-label">{{$t('pmreviewexercisesectioncard.commonkpi')}}</span>
                                        </template>
                                    </v-radio> -->
                                </v-radio-group>
                            </v-col>

                            <v-col v-if="radioSelected === 1" cols="3">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.weightage')"
                                    type="number"
                                    :rules="[rules.required]"
                                    v-model="formData.weightage"
                                    dense
                                    class="v-input"
                                ></v-text-field>
                            </v-col>

                            <v-col v-else cols="3">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.weightage')"
                                    type="number"
                                    :rules="[rules.required]"
                                    v-model="formData.weightage"
                                    dense
                                    class="v-input"
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <div v-if="radioSelected === 1" class="mr-3">
                            <v-row class="pb-n4 mt-n7">
                                <v-autocomplete
                                    outlined
                                    :label="$t('performancemanagement.selectkpi')"
                                    type="text"
                                    ref="kpiitemid"
                                    :rules="[rules.required]"
                                    v-model="formData.kpiitemid"
                                    dense
                                    :items="KPIItemSelectionList"
                                    @change="changeKPIItem(formData.kpiitemid)"
                                ></v-autocomplete>
                            </v-row>
                            <v-row class="pb-n4 mt-n3">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.goal')"
                                    type="text"
                                    :rules="[rules.required]"
                                    v-model="formData.goal"
                                    dense
                                    class="v-input"
                                ></v-text-field>
                            </v-row>
                            <v-row class="pb-n4 mt-n3">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.KPI')"
                                    type="text"
                                    :rules="[rules.required]"
                                    v-model="formData.kpi"
                                    dense
                                    class="v-input"
                                ></v-text-field>
                            </v-row>
                            <v-row class="pb-n4 mt-n6">
                                <v-col cols="4" class="pl-0">
                                    <v-autocomplete
                                        outlined
                                        :label="$t('performancemanagement.targetoption')"
                                        type="text"
                                        ref="pmtargetoptionid"
                                        v-model="formData.pmtargetoptionid"
                                        dense
                                        :items="targetOptionList"
                                        @change="changeTargetOption(formData.pmtargetoptionid)"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="4" class="pl-0">
                                    <v-autocomplete
                                        outlined
                                        :label="$t('pmassementrecord.pmassessmentcalculationmethod')"
                                        type="text"
                                        ref="pmcalmethodid"
                                        v-model="formData.pmcalmethodid"
                                        dense
                                        :items="calculationMethodList"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="4" class="pl-0">
                                    <v-autocomplete
                                        outlined
                                        :label="$t('pmkpiitem.kpifinalscorecalmethod')"
                                        type="text"
                                        ref="pmkpifinalscorecalmethodid"
                                        v-model="formData.pmkpifinalscorecalmethodid"
                                        dense
                                        :items="KPIFinalScoreList"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row class="pb-n4 mt-n8">
                                <v-col cols="12" class="mx-0">
                                    <v-row>
                                        <v-col v-if="formData.targetType !== 'Target only'" cols="3" class="pl-0">
                                            <v-text-field
                                                outlined
                                                :label="$t('pmreviewexercisesectioncard.threshold')"
                                                type="number"
                                                v-model="formData.threshold"
                                                ref="threshold"
                                                dense
                                                class="v-input"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="3" class="pl-0">
                                            <v-text-field
                                                outlined
                                                :label="$t('columns.target')"
                                                type="number"
                                                v-model="formData.target"
                                                ref="target"
                                                dense
                                                class="v-input"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col v-if="formData.targetType !== 'Target only'" cols="3" class="pl-0">
                                            <v-text-field
                                                outlined
                                                :label="$t('pmreviewexercisesectioncard.stretch')"
                                                type="number"
                                                v-model="formData.stretch"
                                                ref="stretch"
                                                dense
                                                class="v-input"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="3" class="pl-0">
                                            <v-text-field
                                                outlined
                                                :label="$t('pmkpiset.subperiodcount')"
                                                type="number"
                                                v-model="formData.subperiodcount"
                                                ref="subperiodcount"
                                                dense
                                                class="v-input"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </div>

                        <div v-else class="mr-3">
                            <v-row class="pb-n4 mt-n7">
                                <v-autocomplete
                                    outlined
                                    :label="$t('performancemanagement.selectkpi')"
                                    type="text"
                                    ref="cmmkpiid"
                                    :rules="[rules.required]"
                                    v-model="formData.cmmkpiid"
                                    dense
                                    :items="commonKPISelectionList"
                                    @change="changeCommonKPI(formData.cmmkpiid)"
                                ></v-autocomplete>
                            </v-row>
                            <v-row class="pb-n4 mt-n3">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.goal')"
                                    type="text"
                                    :rules="[rules.required]"
                                    v-model="formData.goal"
                                    dense
                                    class="v-input"
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-row>
                            <v-row class="pb-n4 mt-n3">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercisesectioncard.KPI')"
                                    type="text"
                                    :rules="[rules.required]"
                                    v-model="formData.kpi"
                                    dense
                                    class="v-input"
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-row>
                            <v-row class="pb-n4 mt-n6">
                                <v-col cols="4" class="pl-0">
                                    <v-autocomplete
                                        outlined
                                        :label="$t('performancemanagement.targetoption')"
                                        type="text"
                                        ref="pmtargetoptionid"
                                        :rules="[rules.required]"
                                        v-model="formData.pmtargetoptionid"
                                        dense
                                        :items="targetOptionList"
                                        @change="changeTargetOption(formData.pmtargetoptionid)"
                                        readonly
                                        background-color="#ffeab2"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="4" class="pl-0">
                                    <v-autocomplete
                                        outlined
                                        :label="$t('pmassementrecord.pmassessmentcalculationmethod')"
                                        type="text"
                                        ref="pmcalmethodid"
                                        :rules="[rules.required]"
                                        v-model="formData.pmcalmethodid"
                                        dense
                                        :items="calculationMethodList"
                                        readonly
                                        background-color="#ffeab2"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row class="pb-n4 mt-n8">
                                <v-col cols="6" class="mx-0">
                                    <v-row>
                                        <v-col v-if="formData.targetType !== 'Target only'" cols="4" class="pl-0">
                                            <v-text-field
                                                outlined
                                                :label="$t('pmreviewexercisesectioncard.threshold')"
                                                type="text"
                                                :rules="[rules.required]"
                                                v-model="formData.threshold"
                                                dense
                                                class="v-input"
                                                readonly
                                                background-color="#ffeab2"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="4" class="pl-0">
                                            <v-text-field
                                                outlined
                                                :label="$t('columns.target')"
                                                type="text"
                                                :rules="[rules.required]"
                                                v-model="formData.target"
                                                dense
                                                class="v-input"
                                                readonly
                                                background-color="#ffeab2"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col v-if="formData.targetType !== 'Target only'" cols="4" class="pl-0">
                                            <v-text-field
                                                outlined
                                                :label="$t('pmreviewexercisesectioncard.stretch')"
                                                type="text"
                                                :rules="[rules.required]"
                                                v-model="formData.stretch"
                                                dense
                                                class="v-input"
                                                readonly
                                                background-color="#ffeab2"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
              </v-container>
            </v-card-text>

            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="saveHandler">{{$t('button.save')}}</v-btn>
              <v-btn color="red darken-1" text @click="closeHandler">{{$t('button.cancel')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-row class="mt-4 ml-6">
                <v-row class="blue--text">
                    <span style="align-content: center;" >{{$t('performancemanagement.objective')}}</span>
                    <v-btn class="ml-5" color="primary" dark @click="openObjective">+</v-btn>
                </v-row>
        </v-row>

        <div v-if="isErr">
        <app-error
            v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
            }"
            v-on:closeError="isErr = $event"
        />
        </div>
    </div>
</template>

<script>
import ErrorDialog from "../../../components/common/ErrorDialog";
import moment from "moment";

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-error": ErrorDialog,
    },

    data() {
        return {
            radioSelected: 1,

            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            formData: {
                kpiexerdid: this.$route.params.id,
                pmtargetoptionid: null,
                pmcalmethodid: null,
                weightage: null,
                goal: null,
                kpi: null,
                target: null,
                threshold: null,
                stretch: null,
                stamp: 0,
                userid: this.$store.getters.userId,
                targetType: null,
                progress: null,
                cmmkpiid: null,
                kpiitemid: null, 
                subperiodcount: 1, // Default to 1 if not set
                pmkpifinalscorecalmethodid: null,
            },

            targetOptionFull: [],
            targetOptionList: [],
            calculationMethodList: [],
            commonKPISelectionList: [],
            commonKPIFull: [],

            KPIItemSelectionList: [],
            KPIItemFull: [],
            KPIFinalScoreList: [],

            individualKPIdialog: false,
            
            //error msg and dialog, check for duplicates vars
            isExisting: false,
            isErr: false,
            errMsg: '',
        }
    },

    watch: {
        radioSelected() {
            this.resetSelections();
        }
    },

    methods: {
        loadTargetOptionListHandler() {
            const vm = this;

            this.$store.dispatch('get', { url: '/kpitargetoption/all' })
            .then((res) => {

                vm.targetOptionFull = res.data.rec;

                for (let i = 0; i < res.data.rec.length; i++) {
                    
                    vm.targetOptionList.push({
                        text: res.data.rec[i].targetoption,
                        value: res.data.rec[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },

        changeTargetOption(id) {
            let item = this.targetOptionFull.find((item) => item.id === id);
            this.formData.targetType = item.targetoption;
        },

        loadCalculationMethodListHandler() {
            const vm = this;
            this.$store.dispatch('get', { url: '/kpicalculationmethod/all' })
            .then((res) => {
                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.calculationMethodList.push({
                        text: res.data.rec[i].calmethod,
                        value: res.data.rec[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },

        loadStaffCommonKPIHandler() {
            const vm = this;
            this.$store.dispatch('get', { url: '/kpiindividual/commonselect/' + vm.formData.kpiexerdid })
            .then((res) => {
                vm.commonKPIFull = res.data.rec;
                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.commonKPISelectionList.push({
                        text: res.data.rec[i].description,
                        goal: res.data.rec[i].goal,
                        kpi : res.data.rec[i].kpi,
                        pmtargetoptionid: res.data.rec[i].pmtargetoptionid,
                        pmcalmethodid: res.data.rec[i].pmcalmethodid,
                        target: res.data.rec[i].target,
                        threshold: res.data.rec[i].threshold,
                        stretch: res.data.rec[i].stretch,
                        weightage: res.data.rec[i].weightage,
                        value: res.data.rec[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },

        loadKPIItemHandler() {
            const vm = this;
            this.$store.dispatch('get', { url: '/kpiitem/individual/staff/' + vm.formData.kpiexerdid })
            .then((res) => {
                vm.KPIItemFull = res.data.rec;
                console.log("KPIItemFull", vm.KPIItemFull);
                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.KPIItemSelectionList.push({
                        text: res.data.rec[i].goal + " - " + res.data.rec[i].kpi,
                        goal: res.data.rec[i].goal,
                        kpi : res.data.rec[i].kpi,
                        pmtargetoptionid: res.data.rec[i].pmtargetoptionid,
                        pmcalmethodid: res.data.rec[i].pmcalmethodid,
                        target: res.data.rec[i].target,
                        threshold: res.data.rec[i].threshold,
                        stretch: res.data.rec[i].stretch,
                        weightage: res.data.rec[i].weightage,
                        value: res.data.rec[i].id,
                    });
                }
                console.log("KPIItemSelectionList", vm.KPIItemSelectionList);
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },

        changeCommonKPI(id){
            let item = this.commonKPIFull.find((item) => item.id === id);
            this.formData.goal = item.goal;
            this.formData.kpi = item.kpi;
            this.formData.pmtargetoptionid = item.pmtargetoptionid;
            this.changeTargetOption(item.pmtargetoptionid);
            this.formData.pmcalmethodid = item.pmcalmethodid;
            this.formData.target = item.target;
            this.formData.threshold = item.threshold;
            this.formData.stretch = item.stretch;
            this.formData.weightage = item.weightage;
        },

        changeKPIItem(id){
            let item = this.KPIItemFull.find((item) => item.id === id);
            this.formData.goal = item.goal;
            this.formData.kpi = item.kpi;
            this.formData.pmtargetoptionid = item.pmtargetoptionid;
            this.changeTargetOption(item.pmtargetoptionid);
            this.formData.pmcalmethodid = item.pmcalmethodid;
            this.formData.target = item.target;
            this.formData.threshold = item.threshold;
            this.formData.stretch = item.stretch;
            this.formData.weightage = item.weightage;
            this.formData.subperiodcount = item.subperiodcount || 1; // Default to 1 if not set
            this.formData.pmkpifinalscorecalmethodid = item.pmkpifinalscorecalmethodid;
        },

        async saveHandler() {
            const vm = this;

            if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
                return false;
            }

            try {
                if (vm.radioSelected == 1) { // Individual KPI
                    const res = await this.$store.dispatch('post', {
                        url: "/kpiindividual/create",
                        payload: vm.formData
                    });

                    if (res.data.error) {
                        vm.isErr = true;
                        vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                    } else {
                        await vm.addProgressReview(res.data.result.id);
                        vm.$emit('add-individual-kpi', res.data.result); 
                        this.closeHandler();
                    }

                } else if (vm.radioSelected == 2) { // Common KPI
                    const res = await this.$store.dispatch('post', {
                        url: "/kpiindividual/common/create",
                        payload: vm.formData
                    });

                    if (res.data.error) {
                        vm.isErr = true;
                        vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                    } else {
                        vm.$emit('add-selected-commonkpi'); 
                        this.closeHandler();
                    }
                }
            } catch (err) {
                vm.isErr = true;
                vm.errMsg = err.message || err;
            }
        },


        async addProgressReview(id){
            console.log("addProgressReview");
            // id - Individual KPI id
            // startdate and enddate - to use to estimate/get the dates in between the subperiod counts 

            // Based on the subperiodcount, I want to get review date(s)
            // Example: subperiodcount = 4, startdate = 2023-01-01, enddate = 2023-12-31
            // I want to generate 4 review dates in between the startdate and enddate
            // Get the appropriate dates based on the subperiodcount

            const vm = this;

            const results = [];

            const start = moment(vm.parentObject.periodstartdate);
            const end = moment(vm.parentObject.periodenddate);

            const subperiodcount = vm.formData.subperiodcount || 1; // Default to 1 if not set
            const intervalDays = end.diff(start, 'day') / subperiodcount;

            for (let i = 1; i <= subperiodcount; i++) {
                const reviewDate = start.clone().add(intervalDays * i, 'days').format('YYYY-MM-DD');
                results.push({
                individualkpiid: id,
                reviewdate: reviewDate
                });
            }

            try {
                const res = await this.$store.dispatch('post', { url: "/kpiexercise/generate/indkpiprg/" + vm.formData.userid , payload: results });

                if (res.status === 201) {
                    console.log("RESINDKPIPRG", res);
                } else {
                    vm.isErr = true;
                }
            } catch (err) {
                console.error('Error in addProgressReview:', err);
                vm.isErr = true;
                vm.errMsg = err;
            }
        },

        openObjective() {
            this.individualKPIdialog = true;
        },

        closeHandler() {
            this.radioSelected = 1;
            this.individualKPIdialog = false;
            this.isErr = false;
            this.resetSelections();
        },

        loadKPIFinalScoreListHandler() {
            const vm = this;
            this.$store.dispatch('get', { url: '/kpifinalscorecalmethod/all' })
            .then((res) => {
                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.KPIFinalScoreList.push({
                        text: res.data.rec[i].description,
                        value: res.data.rec[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },


        resetSelections() {
            this.formData = {
                kpiexerdid: this.$route.params.id,
                pmtargetoptionid: null,
                pmcalmethodid: null,
                weightage: null,
                goal: null,
                kpi: null,
                target: null,
                threshold: null,
                stretch: null,
                stamp: 0,
                userid: this.$store.getters.userId,
                targetType: null,
                cmmkpiid: null,
                kpiitemid: null,
            };
        }
    },

    mounted() {
        this.loadTargetOptionListHandler();
        this.loadCalculationMethodListHandler();
        this.loadKPIFinalScoreListHandler();
        // this.loadStaffCommonKPIHandler(); //Currently add Common KPI from KPI Setting, if need in future just uncomment
        this.loadKPIItemHandler();
    }
}
</script>

<style scoped>

.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-outer-spin-button,
.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-inner-spin-button
{
-webkit-appearance: none;
margin: 0;
}

.mdi-delete::before {
    margin-top: -8px;
}

.mdi-pen::before {
  margin-top: -8px;
}

.radio-label {
    left: 5px;
    position: relative;
}
</style>